
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"101","height":"99","viewBox":"0 0 101 99","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.4 98.6c-.533 0-1.067-.333-1.6-1-.533-.533-.8-1.133-.8-1.8V53.6c0-.667-.267-1-.8-1H2.8c-.667 0-1.333-.2-2-.6-.533-.533-.8-1.133-.8-1.8 0-1.467.4-3.067 1.2-4.8.8-1.867 2-2.8 3.6-2.8h37.8c.533 0 .867-.067 1-.2.267-.267.4-.733.4-1.4V6.8c0-1.867 1.2-3.333 3.6-4.4C50 1.2 51.867.6 53.2.6c.667 0 1.267.267 1.8.8.667.533 1 1.133 1 1.8v39.2c.133.133.267.2.4.2h41c.8 0 1.467.333 2 1 .667.533.867 1.133.6 1.8-.8 2.4-1.6 4.2-2.4 5.4-.8 1.2-2.067 1.8-3.8 1.8h-37c-.533 0-.8.267-.8.8v40.4c0 1.733-1.133 2.933-3.4 3.6-2.267.8-4.333 1.2-6.2 1.2z","fill":"#F4EC4E"}})])
          )
        }
      }
    